import * as Yup from 'yup';
export const CompanyValidations = Yup.object().shape({
  //companyName: Yup.string().max(255).required('Company name is required.'),
});
